
import React, {useContext} from 'react';
import './App.css'

import Health from "./components/utils/health";
import Store, {Context} from "./components/utils/store";
import Routes from "./components/utils/routes";
import AccessControl from "./components/utils/accessControl";
import ErrorBoundary from "./components/error-boundary";

import {
    Switch,
    Route,
    Link,
    BrowserRouter, NavLink
} from "react-router-dom";
import UserStatus from "./components/user_status";





function App() {

    const routes = Routes()
    const publicContents = <div>not authenticated</div>

    return (
        <Store>
            <div className={"nightwatch"}>
                <div className="header">
                    <h2><a href="/">osper nightshift</a></h2>
                    <UserStatus/>
                    <Health/>
                </div>
                <ErrorBoundary>
                    <AccessControl publicChildren={publicContents}>
                        <BrowserRouter>
                            <ul className={"routes"}>
                                {routes.map((r,i) => <li key={i}><NavLink exact to={r.path}>{r.label}</NavLink></li>)}
                            </ul>
                            <Switch>
                                  {routes.map((route, i) => <Route key={i} exact path={route.path} component={route.component} />)}
                            </Switch>
                        </BrowserRouter>
                    </AccessControl>
                </ErrorBoundary>
            </div>
        </Store>
    );
}

export default App;
